import _extends from "@babel/runtime-corejs3/helpers/extends";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import ReactDOM from 'react-dom';
import Notification from './notification';
var notificationInstance = {};
var renderNotification = function renderNotification(properties, el, callback) {
  var _properties$placement = properties.placement,
    placement = _properties$placement === void 0 ? 'default' : _properties$placement,
    props = __rest(properties, ["placement"]);
  var called = false;
  var ref = function ref(notices) {
    notificationInstance[placement] = {
      instance: notices,
      el: el
    };
    if (called) {
      return;
    }
    called = true;
    callback && callback(notices);
  };
  ReactDOM.render( /*#__PURE__*/React.createElement(Notification, _extends({}, props, {
    ref: ref
  })), el);
};
var NotificationApi = {
  add: function add(props, el) {
    var _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'default' : _props$placement;
    if (notificationInstance[placement]) {
      notificationInstance[placement].instance.add(props);
    } else {
      renderNotification(props, el, function (instance) {
        instance.add(props);
      });
    }
  },
  destroy: function destroy(key) {
    if (key) {
      _Object$keys(notificationInstance).forEach(function (placement) {
        var _a;
        var instance = (_a = notificationInstance[placement]) === null || _a === void 0 ? void 0 : _a.instance;
        if (instance) {
          var notices = instance.notices;
          if (Array.isArray(notices) && notices.length) {
            var flag = notices.some(function (notice) {
              return notice.key === key;
            });
            if (flag) {
              instance.remove(key);
            }
          }
        }
      });
    } else {
      _Object$keys(notificationInstance).forEach(function (placement) {
        var _a;
        var el = (_a = notificationInstance[placement]) === null || _a === void 0 ? void 0 : _a.el;
        if (el) {
          ReactDOM.unmountComponentAtNode(el);
          if (el.parentNode) {
            el.parentNode.removeChild(el);
          }
        }
        notificationInstance[placement] = null;
      });
    }
  }
};
export default NotificationApi;